import traverse from 'traverse';

const DEFAULT_REPLACE = '[REDACTED]';

const SECRET_KEYS = [
  /passw(or)?d/i,
  /^pw$/,
  /^pass$/i,
  /secret/i,
  /token/i,
  /api[-._]?key/i,
  /session[-._]?id/i,
  /address1/,
  /address2/,
  /postalCode/,
  /cvv/,
];

const SECRET_VALUES = [
  /^\d{4}[- ]?\d{4}[- ]?\d{4}[- ]?\d{4}$/, // credit card number
];

const keyIsSecret = (str: string) => SECRET_KEYS.some(regex => regex.test(str));
const valueIsSecret = (value: any) =>
  SECRET_VALUES.some(regex => regex.test(value));

const redactObjectValues = (obj: { [key: string]: any }) => {
  traverse(obj).forEach(function (this: any, val: any) {
    if (keyIsSecret(this.key) || valueIsSecret(val)) {
      this.update(DEFAULT_REPLACE);
    }
  });

  return obj;
};

const RedactHelper = {
  redactObjectValues,
};

export default RedactHelper;
